import { Utilities } from "@tylertech/shared-module";
import { MetadataKey } from "../interfaces";
export class MetadataKeyHelpers
{
    static isStringKey(value: MetadataKey): value is string
    {
        return typeof value === "string";
    }

    static isNumberKey(value: MetadataKey): value is number
    {
        return typeof value === "number";
    }

    static isNullKey(value: MetadataKey): boolean
    {
        if (Utilities.IsNullOrUndefined(value)) return true;
        return this.isStringKey(value) ? value === Utilities.emptyGuid || value === "" : value === -1;
    }
}
